import { Snack, Snackbar, Spinner, StatusIconProtoProps } from '@nike/eds';
import { useUserContext } from "../../context/user";
import { FC, useEffect, useState } from "react";
import { PassPolicy } from "../../models/IPassPolicy";
import { VisitorPassGrid } from '../visitor-pass/visitor-pass';
import TAC from '../terms-and-condition/TAC';
import { PassAvailablilityCard } from './pass-availability/pass-availability';
import { Policy } from "./types";
import Pass from '../passes/pass_container/pass';
import { usePassPolicies } from "../../context/PassPolicy";
import style from "./dashboard.module.css";
import { MyPass } from '../visitor-pass/my-pass/my-pass';
import dayjs from 'dayjs';
import { useSponsorContext } from '../../context/Sponsor';
import { VisitorPass } from '../../models/IVisitorPass';

export interface Props {
    modalOpen: boolean;
    onDismiss: ()=>void;
    passToEdit: VisitorPass | null;
}
export const DashboardContent: FC = () => {
    const userInfo = useUserContext();
    const [passAvailability, setPassAvailability] = useState<Policy[]>([]);
    const {sponsor} = useSponsorContext();
    const [tacDetails, setTacDetails] = useState<{
        tacTemplateName: string;
        enabletac: boolean;
    }>({
        tacTemplateName: "",
        enabletac: false
    });
    const passTypesToShow: number[] = [10, 6];
    const { passPolicies } = usePassPolicies();
    const [snackBar, setSnackbar] = useState({ showSnack: false,message: '', snackStatus: "success" as StatusIconProtoProps["status"] });

    const [passProps, setPassProps] = useState<Props>({
        modalOpen: false,
        onDismiss: () =>  setPassProps({ ...passProps, modalOpen: false }),
        passToEdit: null
    });

    const availablePassesToShow = (policies: PassPolicy[]): Policy[] => {
        return policies?.filter((pol) => passTypesToShow.includes(pol.passTypeId))
            .map(pol => ({
                passTypeId: pol.passTypeId,
                displayName: pol.displayName,
                shoppingStartDate: pol.shoppingStartDate,
                shoppingEndDate: pol.shoppingEndDate,
                availablePassesCount: pol.passesAllowed - (pol.passesUsed || 0),
                isUnlimited: pol.passesAllowed === 0,
                isVip: pol.passTypeId === 6
            })).sort((a,b)=> dayjs(a.shoppingEndDate || a.shoppingStartDate).diff(dayjs(b.shoppingEndDate || b.shoppingStartDate))) || [];

    }

    useEffect(() => {
               setPassAvailability(availablePassesToShow(passPolicies));
        }, [passPolicies,passProps]);



    useEffect(() => {
        if (sponsor && sponsor.agreedToTerms === null) {
            setTacDetails({ tacTemplateName: sponsor.tacLocation, enabletac: true });
        }
    }, [userInfo?.passplayUser]);


    const handleRequestPass = () => {
        setPassProps({ ...passProps, modalOpen: true });
    }


return userInfo?.passplayUser?.sponsorId  && !!passPolicies? (
            <>
            <PassAvailablilityCard passPolicies={passAvailability} onRequestPass={handleRequestPass} isModelOpen ={passProps.modalOpen}></PassAvailablilityCard>
            <Pass {...passProps} setPassSnackbar={setSnackbar}/>
            <MyPass/>
            <VisitorPassGrid passPolicies={passPolicies} isModelOpen ={passProps.modalOpen} setSnackBar={setSnackbar}/>
            {tacDetails.enabletac && <TAC tacTemplateName={tacDetails.tacTemplateName}></TAC>}
            <Snackbar>
                { snackBar.showSnack && (
                    <Snack id='pass-snackbar'
                    hideDismiss={true} 
                    className='txt_uppercase'
                    autoDismissDuration={5000} status={snackBar.snackStatus}
                    onDismiss={() => setSnackbar((prev) => ({ ...prev, showSnack: false }))}
                    >
                    {snackBar.message}
                    </Snack>
               )}
          </Snackbar>
        </>):(<>
        <div className={style.dash__loader}>
            <Spinner size="large" />
            <h1 className={style.dash__loadertext}>Loading... </h1>
        </div>
    </>);
};

// export const Dashboard: FC = () => {
//     const userInfo = useUserContext();
//     return (
//     <PassPoliciesProvider userInfo={userInfo}>
//         <DashboardContent />
//     </PassPoliciesProvider>
//     );
// };
